module.exports = __webpack_public_path__ + "static/media/contraceptive-methods.6a4145d2.jpg";